import { Empty, EmptyProps } from 'antd';
import { FC } from 'react';
import emptyIcon from './images/empty-data.png';
import style from './style.scss';

const EmptyData: FC<EmptyProps> = props => {
    const { description, ...restProps } = props;

    return (
        <Empty
            className={style.root}
            description={<div className={style.description}>{description || __('暂无数据')}</div>}
            image={emptyIcon}
            {...restProps}
        />
    );
};

export default EmptyData;
